export const EMOJI_SIZE = 256;
export const ANIMATED_EMOJI_SIZE = 96;
export const BINARY_SIZE_LIMIT = 128000;
export const FRAMERATE_MAX = 60;
export const FRAMECOUNT_MAX = 14;
